const isLocalNetwork = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

const backendDomain = process.env.NODE_ENV === 'development'
    ? (isLocalNetwork ? `http://${window.location.hostname}:5000` : "http://localhost:5000")
    : process.env.NODE_ENV === 'production'
        ? "https://apd-group-biz.onrender.com"
        : "http://192.168.0.15:5000";

const SummaryApi = {
  // ===================== AUTH ROUTES =====================
  registerOrgWithAdmin: {
    url: `${backendDomain}/api/auth/register`,
    method: "post",
  },
  loginEmail: {
    url: `${backendDomain}/api/auth/login-email`,
    method: "post",
  },
  loginMobilePassword: {
    url: `${backendDomain}/api/auth/login-mobile`,
    method: "post",
  },
  sendOtp: {
    url: `${backendDomain}/api/auth/login-mobile/send-otp`,
    method: "post",
  },
  verifyOtp: {
    url: `${backendDomain}/api/auth/login-mobile/verify-otp`,
    method: "post",
  },
  googleLogin: {
    url: `${backendDomain}/api/auth/login-google`,
    method: "post",
  },
  refreshToken: {
    url: `${backendDomain}/api/auth/refresh`, // உங்களது பேக்-எண்ட் refresh route
    method: "POST"
  },
  // ===================== Dashboard ROUTES =====================
  dashboardStats: {
    url: `${backendDomain}/api/dashboard/stats`,
    method: "get",
  },

  getSalespersonStageDashboard: {
    url: `${backendDomain}/api/dashboard/salesperson-stage`,
    method: "get",
  },
  getDivisionDashboard: {
    url: (divisionId) =>
      `${backendDomain}/api/dashboard/division/${divisionId}`,
    method: "get",
  },

  // ===================== STAGE ROUTES =====================
  createStage: {
    url: `${backendDomain}/api/stages/create`,
    method: "post",
  },
  stageReorder: {
    url: `${backendDomain}/api/stages/reorder`,
    method: "post",
  },
  getAllStages: {
    url: `${backendDomain}/api/stages/view-all`,
    method: "get",
  },
  getStagesGroupedByDivision: {
    url: `${backendDomain}/api/stages/grouped-by-division`,
    method: "GET",
  },
  updateStage: {
    url: (stageId) => `${backendDomain}/api/stages/update/${stageId}`,
    method: "put",
  },
  softDeleteStage: {
    url: (stageId) => `${backendDomain}/api/stages/soft-delete/${stageId}`,
    method: "delete",
  },
  permanentDeleteStage: {
    url: (stageId) => `${backendDomain}/api/stages/permanent-delete/${stageId}`,
    method: "delete",
  },

  // ===================== DIVISION ROUTES =====================
  createDivision: {
    url: `${backendDomain}/api/divisions/create`,
    method: "post",
  },
  initializeStages: {
    url: `${backendDomain}/api/stages/initialize-defaults`,
    method: "post",
  },
  getAllDivisions: {
    url: `${backendDomain}/api/divisions/view-all`,
    method: "get",
  },
  getDivisionById: {
    url: (divisionId) =>
      `${backendDomain}/api/divisions/view-one/${divisionId}`,
    method: "get",
  },
  getDivisionUsers: {
    url: (divisionId) => `${backendDomain}/api/divisions/${divisionId}/users`,
    method: "get",
  },
  updateDivision: {
    url: (divisionId) => `${backendDomain}/api/divisions/update/${divisionId}`,
    method: "put",
  },
  deleteDivision: {
    url: (divisionId) => `${backendDomain}/api/divisions/delete/${divisionId}`,
    method: "delete",
  },

  // ===================== DEPARTMENT ROUTES =====================
  createDepartment: {
    url: `${backendDomain}/api/departments/create`,
    method: "post",
  },
  getAllDepartments: {
    url: `${backendDomain}/api/departments/view-all`,
    method: "get",
  },
  getDepartmentById: {
    url: (departmentId) =>
      `${backendDomain}/api/departments/view-one/${departmentId}`,
    method: "get",
  },
  updateDepartment: {
    url: (departmentId) =>
      `${backendDomain}/api/departments/update/${departmentId}`,
    method: "put",
  },
  deleteDepartment: {
    url: (departmentId) =>
      `${backendDomain}/api/departments/delete/${departmentId}`,
    method: "delete",
  },
  getDepartmentUsers: {
    url: (departmentId) =>
      `${backendDomain}/api/departments/${departmentId}/users`,
    method: "get",
  },
  getDepartmentByDivision: {
    url: (divisionId) =>
      `${backendDomain}/api/departments/division/${divisionId}`,
    method: "get",
  },

  // ===================== DESIGNATIONS ROUTES =====================
  createDesignation: {
    url: `${backendDomain}/api/hr/designations/create`,
    method: "post",
  },
  getAllDesignations: {
    url: `${backendDomain}/api/hr/designations/view-all`,
    method: "get",
  },
  getDesignationById: {
    url: (designationId) =>
      `${backendDomain}/api/hr/designations/view-one/${designationId}`,
    method: "get",
  },
  updateDesignation: {
    url: (designationId) =>
      `${backendDomain}/api/hr/designations/update-one/${designationId}`,
    method: "patch",
  },
  deleteDesignation: {
    url: (designationId) =>
      `${backendDomain}/api/hr/designations/delete-one/${designationId}`,
    method: "delete",
  },

  // ===================== ROLE ROUTES =====================
  createRole: {
    url: `${backendDomain}/api/roles/create`,
    method: "post",
  },
  getAllRoles: {
    url: `${backendDomain}/api/roles/view-all`,
    method: "get",
  },
  getRoleById: {
    url: (roleId) => `${backendDomain}/api/roles/view-one/${roleId}`,
    method: "get",
  },
  updateRole: {
    url: (roleId) => `${backendDomain}/api/roles/update/${roleId}`,
    method: "put",
  },
  deleteRole: {
    url: (roleId) => `${backendDomain}/api/roles/delete/${roleId}`,
    method: "delete",
  },
  assignRoleToUser: {
    url: `${backendDomain}/api/roles/assign-to-user`,
    method: "post",
  },
  getRolePermissions: {
    url: (roleId) => `${backendDomain}/api/roles/${roleId}/permissions`,
    method: "get",
  },
  updateRolePermissions: {
    url: (roleId) => `${backendDomain}/api/roles/${roleId}/permissions`,
    method: "put",
  },

  // ===================== INVITE ROUTES =====================
  createInvite: {
    url: `${backendDomain}/api/users/invite`,
    method: "post",
  },
  acceptInvite: {
    url: `${backendDomain}/api/invites/accept`,
    method: "post",
  },
  validateInvite: {
    url: (token) => `${backendDomain}/api/invites/validate/${token}`,
    method: "get",
  },
  getAllInvites: {
    url: `${backendDomain}/api/invites`,
    method: "get",
  },
  getInviteById: {
    url: (inviteId) => `${backendDomain}/api/invites/${inviteId}`,
    method: "get",
  },
  resendInvite: {
    url: (inviteId) => `${backendDomain}/api/invites/${inviteId}/resend`,
    method: "post",
  },
  cancelInvite: {
    url: (inviteId) => `${backendDomain}/api/invites/${inviteId}/cancel`,
    method: "delete",
  },
  getInviteStats: {
    url: `${backendDomain}/api/invites/stats`,
    method: "get",
  },

  // ===================== USER ROUTES =====================
  createUser: {
    url: `${backendDomain}/api/users/create`,
    method: "post",
  },
  getAllUsers: {
    url: `${backendDomain}/api/users/view-all`,
    method: "get",
  },
  viewOneUser: {
    url: (userId) => `${backendDomain}/api/users/view-one/${userId}`,
    method: "get",
  },
  updateUser: {
    url: (userId) => `${backendDomain}/api/users/update/${userId}`,
    method: "put",
  },
  updateUserDivisions: {
    url: (userId) => `${backendDomain}/api/users/permissions/divisions/${userId}`,
    method: "put",
  },
  executiveUsers: {
    url: `${backendDomain}/api/users/executive`,
    method: "get",
  },
  // ===================== EXPO LEADS ADMIN ROUTES =====================
  convertExpoLeadToVisit: {
    url: (expoLeadId) => `${backendDomain}/api/expo/convert-to-visit/${expoLeadId}`,
    method: "post"
  },
  uploadUserPicture: {
    url: (userId) =>
      `${backendDomain}/api/users/update/${userId}/profile-picture`,
    method: "put",
  },
  deleteUser: {
    url: (userId) => `${backendDomain}/api/users/${userId}`,
    method: "delete",
  },
  deactivateUser: {
    url: (userId) => `${backendDomain}/api/users/${userId}/deactivate`,
    method: "put",
  },
  getUserPermissions: {
    url: (userId) => `${backendDomain}/api/users/${userId}/permissions`,
    method: "get",
  },
  getUserRoles: {
    url: (userId) => `${backendDomain}/api/users/${userId}/roles`,
    method: "get",
  },
  updateUserPermissions: {
    url: (userId) => `${backendDomain}/api/users/permissions/override/${userId}`,
    method: "put",
  },
  getMe: {
    url: `${backendDomain}/api/users/me`,
    method: "get",
  },
  // ===================== INVITATION ROUTES =====================
  getAllInvitations: {
    url: `${backendDomain}/api/invites/view-all`,
    method: "get",
  },
  resendInvitation: {
    url: (id) => `${backendDomain}/api/invites/resend/${id}`,
    method: "post",
  },
  deleteInvitation: {
    url: (id) => `${backendDomain}/api/invites/delete/${id}`,
    method: "delete",
  },

  // ===================== ORGANIZATION ROUTES =====================
  getOrgDetails: {
    url: `${backendDomain}/api/organizations/view`,
    method: "get",
  },
  getOrgStats: {
    url: `${backendDomain}/api/organizations/stats`,
    method: "get",
  },
  updateOrg: {
    url: `${backendDomain}/api/organizations/update`,
    method: "put",
  },
  uploadOrgPicture: {
    url: `${backendDomain}/api/organizations/upload-picture`,
    method: "put",
  },
  deleteOrgPicture: {
    url: `${backendDomain}/api/organizations/delete-picture`,
    method: "delete",
  },
  getOrgSettings: {
    url: `${backendDomain}/api/organizations/settings`,
    method: "get",
  },
  updateOrgSettings: {
    url: `${backendDomain}/api/organizations/settings`,
    method: "put",
  },

  // ===================== PERMISSIONS ROUTES =====================
  getPermissionCategories: {
    url: `${backendDomain}/api/permissions/categories`,
    method: "get",
  },
  getPermissionsByModule: {
    url: (module) => `${backendDomain}/api/permissions/module/${module}`,
    method: "get",
  },

  // **   Sales Routes  **//
//SALS SETTING ROUTES//
// ===================== PROGRAM / OFFERING ROUTES =====================
  createProgram: {
    url: `${backendDomain}/api/sales/program/create`,
    method: "post",
  },
  getAllPrograms: {
    url: `${backendDomain}/api/sales/program/view-all`,
    method: "get",
  },
  getProgramById: {
    url: (id) => `${backendDomain}/api/sales/program/view-one/${id}`,
    method: "get",
  },
  updateProgram: {
    url: (id) => `${backendDomain}/api/sales/program/update-one/${id}`,
    method: "put",
  },
  deleteProgram: {
    url: (id) => `${backendDomain}/api/sales/program/delete-one/${id}`,
    method: "delete",
  },

  // ===================== CLIENT ROUTES =====================//
  // createClient: {
  //   url: `${backendDomain}/api/clients/create`,
  //   method: "post",
  // },
  getAllClients: {
    url: `${backendDomain}/api/sales/client-list/view-all`,
    method: "get",
  },
  // ===================== CLIENT VISIT ROUTES =====================
  duplicateClients: {
    url: `${backendDomain}/api/client-visits/duplicate-clients`,
    method: "get",
  },
    deleteOneClient: {
    url: (id) => `${backendDomain}/api/client-visits/soft-delete/${id}`,
    method: "patch",
  },
  
  createClientVisit: {
    url: `${backendDomain}/api/client-visits/create`,
    method: "post",
  },
  getAllClientVisits: {
    url: `${backendDomain}/api/client-visits/view-all`,
    method: "get",
  },
  // Add to SummaryApi
  getAllClientVisitsReport: {
    url: `${backendDomain}/api/client-visits/report/all`,
    method: "get",
  },
  getOneClientVisit: {
    url: (id) => `${backendDomain}/api/client-visits/view-one/${id}`,
    method: "get",
  },
  updateClientVisit: {
    url: (id) => `${backendDomain}/api/client-visits/update/${id}`,
    method: "put",
  },
  deleteClientVisit: {
    url: (id) => `${backendDomain}/api/client-visits/delete/${id}`,
    method: "delete",
  },
  togglePriority: {
    url: (id) => `${backendDomain}/api/client-visits/priority/${id}`,
    method: "patch",
  },
  addFollowUp: {
    url: (dealId) => `${backendDomain}/api/client-visits/follow-up/${dealId}`,
    method: "post",
  },
  getUpcomingFollowUps: {
    url: `${backendDomain}/api/client-visits/follow-ups/upcoming`,
    method: "get",
  },
  getFollowUpsByDateRange: {
    url: `${backendDomain}/api/client-visits/follow-ups/date-range`,
    method: "get",
  },
  getFollowUpDashboard: {
    url: `${backendDomain}/api/client-visits/follow-ups/dashboard`,
    method: "get",
  },
  getTodayFollowUps: {
    url: `${backendDomain}/api/client-visits/follow-ups/today`,
    method: "get",
  },
  getOverdueFollowUps: {
    url: `${backendDomain}/api/client-visits/follow-ups/overdue`,
    method: "get",
  },
  updateVisitStage: {
    url: (id) => `${backendDomain}/api/client-visits/update-stage/${id}`,
    method: "put",
  },
  getClientHistory: {
    url: (clientId) =>
      `${backendDomain}/api/client-visits/client-history/${clientId}`,
    method: "get",
  },
  getClientVisitStats: {
    url: `${backendDomain}/api/client-visits/stats`,
    method: "get",
  },
  userWiseFollowupReport: {
    url: `${backendDomain}/api/client-visits/follow-ups/reports/daily-user-detailed`,
    method: "get",
  },
  getAllWonClients: {
    url: `${backendDomain}/api/client-visits/won-clients`,
    method: "get",
  },
  getClientMapData: {
    url: `${backendDomain}/api/client-visits/map-data`,
    method: "get",
  },
  // getUpcomingFollowUps: {
  //     url: (days = 7) => `${backendDomain}/api/client-visits/upcoming-followups?days=${days}`,
  //     method: "get"
  // },
  // ** Reports **//
  clientStageReportOverview: {
    url: `${backendDomain}/api/reports/stages/client-visit/overview`,
    method: "get",
  },
  clientStageListReport: {
    url: `${backendDomain}/api/reports/stages/client-visit/list`,
    method: "get",
  },
  clientStageHistoryReport: {
    url: `${backendDomain}/api/reports/stages/client-visit/history`,
    method: "get",
  },
  clientStageDurationReport:{
    url: `${backendDomain}/api/reports/stages/client-visit/duration`,
    method: "get",
  },
  getOnboardingCalendar:{
    url: `${backendDomain}/api/onboarding/client/report-calendar`,
    method: "get",
  },
  //Onboarding Clients & Templates
  createOnboardingTemplate: {
    url: `${backendDomain}/api/onboarding/templates/create`,
    method: "post",
  },
  getAllOnboardingTemplates: {
    url: `${backendDomain}/api/onboarding/templates/view-all`,
    method: "get",
  },
  getOneOnboardingTemplate: {
    url: (id) => `${backendDomain}/api/onboarding/templates/view-one/${id}`,
    method: "get",
  },
  updateOnboardingTemplate: {
    url: (id) => `${backendDomain}/api/onboarding/templates/update/${id}`,
    method: "put",
  },
  deleteOnboardingTemplate: {
    url: (id) => `${backendDomain}/api/onboarding/templates/delete/${id}`,
    method: "delete",
  },
  cloneOnboardingTemplate: {
    url: (id) => `${backendDomain}/api/onboarding/templates/${id}/clone`,
    method: "post",
  },
  seedDefaultTemplate: {
    url: `${backendDomain}/api/onboarding/templates/seed-default`,
    method: "post",
  },

  //Client Onboarding
  startClientOnboarding: {
    url: `${backendDomain}/api/onboarding/client/start`,
    method: "post",
  },
  getOneClientOnboarding: {
    url: (id) => `${backendDomain}/api/onboarding/client/view-one/${id}`,
    method: "get",
  },
  updateClientOnboardingChecklist: {
    url: `${backendDomain}/api/onboarding/client/update-checklist`,
    method: "patch",
  },
  // updateClientOnboarding: {
  //   url: (id) => `${backendDomain}/api/onboarding/client/update/${id}`,
  //   method: "put",
  // },
  deleteClientOnboarding: {
    url: (id) => `${backendDomain}/api/onboarding/client/delete/${id}`,
    method: "delete",
  },
  getClientOnboardingHistory: {
    url: (id) => `${backendDomain}/api/onboarding/client/history/${id}`,
    method: "get",
  },
  getClientOnboardingDashboard: {
    url: (id) => `${backendDomain}/api/onboarding/client/dashboard/${id}`,
    method: "get",
  },
  OnboardingPhaseAttachment: {
    url: `${backendDomain}/api/onboarding/client/phase-attachments`,
    method: "post",
  },
  updateHandleBy: {
    url: (id) => `${backendDomain}/api/onboarding/client/update-handle-by/${id}`,
    method: "put",
  },
  updateClientStatus: {
    url: (id) => `${backendDomain}/api/onboarding/client/update-client-status/${id}`,
    method: "put",
  },
  updateClientType: {
    url: (id) => `${backendDomain}/api/onboarding/client/update-client-type/${id}`,
    method: "put",
  },


  //MIS Report Routes
  getMISDashboard:{
    url: `${backendDomain}/api/mis-report/dashboard`,
    method: "get",
  },
  getLeadLeakageReport:{
    url: `${backendDomain}/api/mis-report/lead-leakage`,
    method: "get",
  },
  getRevenueForecast: {
    url: `${backendDomain}/api/mis-report/revenue-forecast`,
    method: "get",
  },
  getPipelineStageAnalysis: {
    url: `${backendDomain}/api/mis-report/pipeline-stage-analysis`,
    method: "get",
  },
  getTopSalesPerformers: {
    url: `${backendDomain}/api/mis-report/top-sales-performers`,
    method: "get",
  },
  getFollowupPerformance: {
    url: `${backendDomain}/api/mis-report/followup-performance`,
    method: "get",
  },
  getLeadAgingReport: {
    url: `${backendDomain}/api/mis-report/lead-aging`,
    method: "get",
  },
  getPipelineDistribution: {
    url: `${backendDomain}/api/mis-report/pipeline-distribution`,
    method: "get",
  },
  getMonthlyLeadTrend:{
    url: `${backendDomain}/api/mis-report/monthly-lead-trend`,
    method: "get",
  },
  getIndustryAnalysis:{
    url: `${backendDomain}/api/mis-report/industry-analysis`,
    method: "get",
  },


  //** HR ROUTES */
  // ===================== RECRUITMENT ROUTES =====================
  viewAllCareersJobs: {
    url: `${backendDomain}/api/hr/careers/jobs/view-all`,
    method: "get",
  },
  createRecruitmentJob: {
    url: `${backendDomain}/api/hr/recruitment/jobs/create`,
    method: "post",
  },
  getRecruitmentJobById: {
    url: (id) => `${backendDomain}/api/hr/recruitment/jobs/view-one/${id}`,
    method: "get",
  },
  getAllRecruitmentJobs: {
    url: `${backendDomain}/api/hr/recruitment/jobs/view-all`,
    method: "get",
  },
  publishJobOpening: {
    url: (id) => `${backendDomain}/api/hr/recruitment/jobs/${id}/publish`,
    method: "post",
  },
  closeJobOpening: {
    url: (id) => `${backendDomain}/api/hr/recruitment/jobs/${id}/close`,
    method: "post",
  },
  updateRecruitmentJob: {
    url: (id) => `${backendDomain}/api/hr/recruitment/jobs/update-one/${id}`,
    method: "put",
  },
  deleteRecruitmentJob: {
    url: (id) => `${backendDomain}/api/hr/recruitment/jobs/delete-one/${id}`,
    method: "delete",
  },

  // ===================== RECRUITMENT CANDIDATES ROUTES =====================
  getRecruitmentDashboardStats: {
      url: `${backendDomain}/api/hr/recruitment/dashboard/stats`,
      method: "get",
  },
 
  careerApply: {
    url: `${backendDomain}/api/hr/careers/apply`,
    method: "post",
  },
  getAllCandidates: {
    url: `${backendDomain}/api/hr/recruitment/candidates/view-all`,
    method: "get",
  },
  getCandidatesById: {
    url: (id) => `${backendDomain}/api/hr/recruitment/candidates/view-one/${id}`,
    method: "get",
  },
  updateCandidates: {
    url: (id) => `${backendDomain}/api/hr/recruitment/candidates/update-one/${id}`,
    method: "put",
  },
  candidateMovestage: {
    url: (id) => `${backendDomain}/api/hr/recruitment/candidates/${id}/move-stage`,
    method: "post",
  },
  getMyAssignedInterviews: {
    url: `${backendDomain}/api/hr/recruitment/interviews/my-assigned`,
    method: "get",
  },
  candidateScheduleInterview: {
    url: (id) => `${backendDomain}/api/hr/recruitment/candidates/${id}/schedule-interview`,
    method: "post",
  },
  candidateScheduleInterviewUpdate: {
    url: (id, interviewId) => `${backendDomain}/api/hr/recruitment/candidates/${id}/interviews/${interviewId}/schedule-interview/update`,
    method: "put",
  },
  candidateSubmitInterviewFeedback: {
    url: (id, interviewId) => `${backendDomain}/api/hr/recruitment/candidates/${id}/interviews/${interviewId}/feedback`,
    method: "post",
  },
  deleteCandidate: {
    url: (id) => `${backendDomain}/api/hr/careers/jobs/delete-one/${id}`,
    method: "delete",
  },

  // ===================== OFFERS ROUTES =====================
  createCandidateOffer: {
    url: `${backendDomain}/api/hr/recruitment/offers/create`,
    method: "post",
  },
  getAllCandidateOffers: {
    url: `${backendDomain}/api/hr/recruitment/offers/view-all`,
    method: "get",
  },
  getCandidateOfferById: {
    url: (id) => `${backendDomain}/api/hr/recruitment/offers/view-one/${id}`,
    method: "get",
  },
  updateCandidateOffer: {
    url: (id) => `${backendDomain}/api/hr/recruitment/offers/update-one/${id}`,
    method: "put",
  },
  deleteCandidateOffer: {
    url: (id) => `${backendDomain}/api/hr/recruitment/offers/delete-one/${id}`,
    method: "delete",
  },
  getCandidatePublicOffer: {
    url: (id) => `${backendDomain}/api/hr/careers/offers/${id}/public-offer`,
    method: "get",
  },
  sendCandidateOffer: {
    url: (id) => `${backendDomain}/api/hr/recruitment/offers/${id}/send-offer`,
    method: "post",
  },
  respondCandidateOffer: {
    url: (id) => `${backendDomain}/api/hr/careers/offers/${id}/respond-offer`,
    method: "post",
  },
  withdrawCandidateOffer: {
    url: (id) => `${backendDomain}/api/hr/recruitment/offers/${id}/withdraw-offer`,
    method: "post",
  },

// ===================== HR - ONBOARDING LIFECYCLE =====================
  getAllOnboarding: {
    url: `${backendDomain}/api/hr/onboarding/view-all`,
    method: "get",
  },
  getOnboardingById: {
    url: (id) => `${backendDomain}/api/hr/onboarding/view-one/${id}`,
    method: "get",
  },
  cancelOnboarding: {
    url: (id) => `${backendDomain}/api/hr/onboarding/cancel-one/${id}`,
    method: "post",
  },
  updateOnboarding: {
    url: (id, sectionId) => `${backendDomain}/api/hr/onboarding/${id}/update-sections/${sectionId}`,
    method: "put",
  },
  
  // 👈 Fix: Changed from PUT to POST to match your backend route definition
  updateBackgroundVerification: {
    url: (id) => `${backendDomain}/api/hr/onboarding/background-verification/${id}`,
    method: "post",
  },
  
  // 👈 Fix: Changed from PUT to POST to match your backend route definition
  approvalOnboarding: {
    url: (id) => `${backendDomain}/api/hr/onboarding/approval/${id}`,
    method: "post",
  },

  // ===================== ONBOARDING DOCUMENTS =====================
  listDocuments: {
    url: (onboardingId) => `${backendDomain}/api/hr/onboarding/${onboardingId}/documents`,
    method: "get",
  },
  generateDocument: {
    url: (id) => `${backendDomain}/api/hr/onboarding/documents/${id}/generate`,
    method: "post",
  },
  markDocumentViewed: {
    url: (id) => `${backendDomain}/api/hr/onboarding/documents/${id}/view`,
    method: "post",
  },
  signDocument: {
    url: (id) => `${backendDomain}/api/hr/onboarding/documents/${id}/sign`,
    method: "post",
  },
  rejectDocument: {
    url: (id) => `${backendDomain}/api/hr/onboarding/documents/${id}/reject`,
    method: "post",
  },
  uploadSupportingDocument: {
    url: (id) => `${backendDomain}/api/hr/onboarding/documents/${id}/upload`,
    method: "post",
  },
  // ===================== EMPLOYEE ROUTES =====================
  getAllEmployees:{
    url: `${backendDomain}/api/hr/employees/view-all`,
    method: "get",
  },
  getOneEmployee:{
    url: (id) => `${backendDomain}/api/hr/employees/view-one/${id}`,
    method: "get",
  },
  createEmployee:{
    url: `${backendDomain}/api/hr/employees/create`,
    method: "post",
  },
  updateEmployee: {
    url: (id) => `${backendDomain}/api/hr/employees/update-one/${id}`,
    method: "put",
  },
  deleteEmployee: {
    url: (id) => `${backendDomain}/api/hr/employees/delete-one/${id}`,
    method: "delete",
  },
  getReporteesList: {
    url: `${backendDomain}/api/hr/employees/reportees`,
    method: "get"
  },
  // ===================== EMPLOYEE FINANCE ROUTES =====================
  getOneEmployeeFinance: {
    url: (id) => `${backendDomain}/api/hr/employees/employee-finance/${id}`,
    method: "get",
  },
  saveOneEmployeeFinance: {
    url: (id) => `${backendDomain}/api/hr/employees/employee-finance/${id}`,
    method: "put",
  },

  // ===================== SHIFT ROUTES =====================
  createShift: {
    url: `${backendDomain}/api/hr/shifts/create`,
    method: "post",
  },
  getAllShifts:{
    url: `${backendDomain}/api/hr/shifts/view-all`,
    method: "get",
  },
  getShiftById: {
    url: (shiftId) => `${backendDomain}/api/hr/shifts/view-one/${shiftId}`,
    method: "get",
  },
  updateShift: {
    url: (shiftId) => `${backendDomain}/api/hr/shifts/update-one/${shiftId}`,
    method: "patch",
  },
  deleteShift: {
    url: (shiftId) => `${backendDomain}/api/hr/shifts/delete-one/${shiftId}`,
    method: "delete",
  },


    // ===================== HOLIDAY ROUTES =====================
  createHoliday: {
    url: `${backendDomain}/api/hr/holidays/create`,
    method: "post",
  },
  getAllHoliday:{
    url: `${backendDomain}/api/hr/holidays/view-all`,
    method: "get",
  },
  // getHolidayById: {
  //   url: (shiftId) => `${backendDomain}/api/hr/holidays/view-one/${shiftId}`,
  //   method: "get",
  // },
  updateHoliday: {
    url: (shiftId) => `${backendDomain}/api/hr/holidays/update-one/${shiftId}`,
    method: "patch",
  },
  deleteHoliday: {
    url: (shiftId) => `${backendDomain}/api/hr/holidays/delete-one/${shiftId}`,
    method: "delete",
  },

  // ===================== ATTENDANCE ROUTES =====================
   getTodayAttendanceStatus:{
    url: `${backendDomain}/api/hr/attendance/check-in-out/today`,
    method: "get",
   },
   checkIn:{
    url: `${backendDomain}/api/hr/attendance/check-in`,
    method: "post",
   },
   checkOut:{
    url: `${backendDomain}/api/hr/attendance/check-out`,
    method: "post",
   },
   weeklyAttendanceStatus:{
    url: `${backendDomain}/api/hr/attendance/this-week`,
    method: "get",
   },
   reporteesTdyAttendanceStatus:{
    url: `${backendDomain}/api/hr/attendance/reportees/today`,
    method: "get",
   },
   teamTdyAttendanceStatus:{
    url: `${backendDomain}/api/hr/attendance/team/today`,
    method: "get",
   },
   getMyAttendaceCalendar:{
    url: `${backendDomain}/api/hr/attendance/my-calendar`,
    method: "get",
   },
   getAllAttendaceReport:{
    url: `${backendDomain}/api/hr/attendance/report`,
    method: "get",
   },
  // ===================== REGULARIZATION ATTENDANCE ROUTES =====================
  getDayAttendanceDetails: {
    url: `${backendDomain}/api/hr/attendance/regularize/day-details`,
    method: "get",
  },
  requestRegularization: {
    url: `${backendDomain}/api/hr/attendance/regularize/create`,
    method: "post",
  },
  viewMyRegularization:{
    url: `${backendDomain}/api/hr/attendance/regularize/my`,
    method: "get",
  },
  viewReporteesRegularization:{
    url: `${backendDomain}/api/hr/attendance/regularize/reportees`,
    method: "get",
  },
  viewAllRegularization:{
    url: `${backendDomain}/api/hr/attendance/regularize/admin`,
    method: "get",
  },
  approveRegularization: {
    url: (id) => `${backendDomain}/api/hr/attendance/regularize/approve/${id}`,
    method: "put",
  },
  rejectRegularization: {
    url: (id) => `${backendDomain}/api/hr/attendance/regularize/reject/${id}`,
    method: "put",
  },

  // ===================== PAYROLL SETTINGS GRADES ROUTES =====================

  getAllPayrollGrades: {
    url: `${backendDomain}/api/hr/payroll/grades`,
    method: "get",
  },
  getPayrollGradeById: {
    url: (payrollGradeId) =>
      `${backendDomain}/api/hr/payroll/grades/${payrollGradeId}`,
    method: "get",
  },
  getPayrollGradeTemplateById: {
    url: (payrollGradeId) =>
      `${backendDomain}/api/hr/payroll/grades/template/${payrollGradeId}`,
    method: "get",
  },
  createPayrollGrade: {
    url: `${backendDomain}/api/hr/payroll/grades`,
    method: "post",
  },
  updatePayrollGrade: {
    url: (payrollGradeId) =>
      `${backendDomain}/api/hr/payroll/grades/${payrollGradeId}`,
    method: "patch",
  },
  deletePayrollGrade: {
    url: (payrollGradeId) =>
      `${backendDomain}/api/hr/payroll/grades/${payrollGradeId}`,
    method: "delete",
  },

  //**  ===================== LEAVE MANAGEMENT ROUTES ===================== */

  // ===================== LEAVE TYPES ROUTES =====================
  createLeaveType: {
    url: `${backendDomain}/api/hr/leave-types/create`,
    method: "post",
  },
  getAllLeaveTypes:{
    url: `${backendDomain}/api/hr/leave-types/view-all`,
    method: "get",
  },
  getMyLeaveTypes:{
    url: `${backendDomain}/api/hr/leave-types/my`,
    method: "get",
  },
  updateLeaveType: {
    url: (shiftId) => `${backendDomain}/api/hr/leave-types/update-one/${shiftId}`,
    method: "put",
  },
  deleteLeaveTypes: {
    url: (shiftId) => `${backendDomain}/api/hr/leave-types/delete-one/${shiftId}`,
    method: "delete",
  },

  // ===================== LEAVE POLICIES ROUTES =====================
  createLeavePolicy: {
    url: `${backendDomain}/api/hr/leave-policies`,
    method: "post",
  },
  getAllLeavePolicies: {
    url: `${backendDomain}/api/hr/leave-policies`,
    method: "get",
  },
  updateLeavePolicy: {
    url: (policyId) => `${backendDomain}/api/hr/leave-policies/${policyId}`,
    method: "put", // OR "patch" based on your backend
  },

  // ===================== LEAVE BALANCES ROUTES =====================
  getMyBalance: {
    url: `${backendDomain}/api/hr/leave-balance/me`,
    method: "get",
  },
  initLeaveBalance: {
    url: `${backendDomain}/api/hr/leave-balance/init`,
    method: "post",
  },
  getUserLeaveBalance: {
    url: (userId) => `${backendDomain}/api/hr/leave-balance/${userId}`,
    method: "get",
  },
  updateLeaveBalance: {
    url: (userId) => `${backendDomain}/api/hr/leave-balance/${userId}/override`,
    method: "put", // OR "patch" based on your backend
  },
  accrueManual: {
    url: `${backendDomain}/api/hr/leave-balance/accrue-manual`,
    method: "post",
  },

  // ===================== LEAVE REQUEST ROUTES =====================
  applyLeave: {
    url: `${backendDomain}/api/hr/leaves/leave-request/apply`,
    method: "post",
  },
  getAllLeaveRequests: {
    url: `${backendDomain}/api/hr/leaves/leave-request/view-all`,
    method: "get",
  },
  approveLeaveRequest: {
    url: (requestId) => `${backendDomain}/api/hr/leaves/leave-request/${requestId}/approve`,
    method: "put", // OR "patch" based on your backend
  },
  rejectLeaveRequest: {
    url: (requestId) => `${backendDomain}/api/hr/leaves/leave-request/${requestId}/reject`,
    method: "put", // OR "patch" based on your backend
  },
  cancelLeave: {
    url: (requestId) => `${backendDomain}/api/hr/leaves/leave-request/${requestId}/cancel`,
    method: "put", // OR "patch" based on your backend
  },
  getReporteesLeaves: {
    url: `${backendDomain}/api/hr/leaves/reportees`,
    method: "get"
  },

  // ===================== HOURLY PERMISSION ROUTES =====================
  requestPermission: {
    url: `${backendDomain}/api/hr/permission/create`,
    method: "post"
  },
  myPermissions: {
    url: `${backendDomain}/api/hr/permission/my`,
    method: "get"
  },
  permissionReporteesList: {
    url: `${backendDomain}/api/hr/permission/reportees`, // Manager can see reportees requests
    method: "get"
  },
  getAllPermissionList: {
    url: `${backendDomain}/api/hr/permission/view-all`, // HR/Admin can see all requests
    method: "get"
  },
  approvePermission: {
    url: (id) => `${backendDomain}/api/hr/permission/approve/${id}`, // :id will be replaced dynamically
    method: "put"
  },
  rejectPermission: {
    url: (id) => `${backendDomain}/api/hr/permission/reject/${id}`, // :id will be replaced dynamically
    method: "put"
  },
  permissionCancel: {
    url: (id) => `${backendDomain}/api/hr/permission/cancel/${id}`,
    method: "put"
  },


  // ===================== COMP OFF ROUTES =====================
  requestCompOff: {
    url: `${backendDomain}/api/hr/compoff/create`,
    method: "post"
  },
  myCompOffs: {
    url: `${backendDomain}/api/hr/compoff/my`,
    method: "get"
  },
  compOffReporteesList: {
    url: `${backendDomain}/api/hr/compoff/reportees`, // Manager can see reportees requests
    method: "get"
  },
  getAllCompOffList: {
    url: `${backendDomain}/api/hr/compoff/view-all`, // HR/Admin can see all requests
    method: "get"
  },
  approveCompOff: {
    url: (id) => `${backendDomain}/api/hr/compoff/approve/${id}`, // :id will be replaced dynamically
    method: "put"
  },
  rejectCompOff: {
    url: (id) => `${backendDomain}/api/hr/compoff/reject/${id}`, // :id will be replaced dynamically
    method: "put"
  },
  compOffDelete: {
    url: (id) => `${backendDomain}/api/hr/compoff/delete/${id}`,
    method: "delete"
  },
  compOffAvailable: {
    url: `${backendDomain}/api/hr/compoff/available`,
    method: "get"
  },
  //**  ===================== KRA FLOW ROUTES ===================== */

  // ===================== KRA PERFORMANCE REVIEW WORKFLOW ROUTES =====================
  craeteKRAReviewWorkflow: {
    url: `${backendDomain}/api/hr/performance/workflows/create`,
    method: "post",
  },
  getAllKRAReviewWorkflows: {
    url: `${backendDomain}/api/hr/performance/workflows/view-all`,
    method: "get",
  },
  getKRAReviewWorkflowById: {
    url: (workflowId) =>
      `${backendDomain}/api/hr/performance/workflows/view-one/${workflowId}`,
    method: "get",
  },
  updateKRAReviewWorkflow: {
    url: (workflowId) =>
      `${backendDomain}/api/hr/performance/workflows/update-one/${workflowId}`,
    method: "put",
  },
  deleteKRAReviewWorkflow: {
    url: (workflowId) =>
      `${backendDomain}/api/hr/performance/workflows/delete-one/${workflowId}`,
    method: "delete",
  },

  // ===================== KRA TEMPLATE ROUTES =====================
  createKraTemplate: {
    url: `${backendDomain}/api/hr/kra/templates/create`,
    method: "post",
  },
  getAllKraTemplates: {
    url: `${backendDomain}/api/hr/kra/templates/view-all`,
    method: "get",
  },
  getKraTemplateById: {
    url: (templateId) =>
      `${backendDomain}/api/hr/kra/templates/view-one/${templateId}`,
    method: "get",
  },
  updateKraTemplate: {
    url: (templateId) =>
      `${backendDomain}/api/hr/kra/templates/update-one/${templateId}`,
    method: "put",
  },
  deleteKraTemplate: {
    url: (templateId) =>
      `${backendDomain}/api/hr/kra/templates/delete-one/${templateId}`,
    method: "delete",
  },
  
  // ===================== KRA BUNDLE ROUTES =====================
  createKraBundle: {
    url: `${backendDomain}/api/hr/kra/bundles/create`,
    method: "post",
  },
  getAllKraBundles: {
    url: `${backendDomain}/api/hr/kra/bundles/view-all`,
    method: "get",
  },
  getKraBundleById: {
    url: (bundleId) =>
      `${backendDomain}/api/hr/kra/bundles/view-one/${bundleId}`,
    method: "get",
  },
  updateKraBundle: {
    url: (bundleId) =>
      `${backendDomain}/api/hr/kra/bundles/update-one/${bundleId}`,
    method: "put",
  },
  deleteKraBundle: {
    url: (bundleId) =>
      `${backendDomain}/api/hr/kra/bundles/delete-one/${bundleId}`,
    method: "delete",
  },

  // ===================== KRA ASSIGNMENT ROUTES =====================
  assignKra: {
    url: `${backendDomain}/api/hr/kra/assign`,
    method: "post",
  },
  listKraAssignments: {
    url: `${backendDomain}/api/hr/kra/assignments/view-all`,
    method: "get",
  },
  updateAssignKra: {
    url: (id) =>
      `${backendDomain}/api/hr/kra/assignments/update-one/${id}`,
    method: "get",
  },
  getEmployeeKras: {
    url: (userId) =>
      `${backendDomain}/api/hr/kra/assignments/employee/view-one/${userId}`,
    method: "get",
  },
  employeeAcknowledgeKra: {
    url: `${backendDomain}/api/hr/kra/my-kras/acknowledge`,
    method: "put",
  },
  getMyKra: {
    url: `${backendDomain}/api/hr/kra/my-kras`,
    method: "get",
  },
  deleteEmployeeKras: {
    url: (id) =>
      `${backendDomain}/api/hr/kra/assignments/delete-one/${id}`,
    method: "get",
  },
  // ===================== KRA ASSIGNMENT REVIEW ROUTES =====================
  reviewInitiateKra: {
    url: `${backendDomain}/api/hr/kra/reviews/initiate`,
    method: "post"
  },
  bulkReviewInitiateKra: {
    url: `${backendDomain}/api/hr/kra/reviews/bulk-initiate`,
    method: "post"
  },
  autoInitiateReviews: {
    url: `${backendDomain}/api/hr/kra/reviews/auto-cron-initiate`,
    method: "post"
  },
  updateInitiatedReview: {
    url: (id) =>
      `${backendDomain}/api/hr/kra/reviews/update-one/${id}`,
    method: "put",
  },
  skipKraReviewStage: {
    url: `${backendDomain}/api/hr/kra/reviews/skip-stage`,
    method: "post"
  },
  getMyKraReview: {
    url: `${backendDomain}/api/hr/kra/reviews/my-reviews`,
    method: "get",
  },
  startKraReviewEvaluate: {
    url: `${backendDomain}/api/hr/kra/reviews/evaluate`,
    method: "post"
  },
  getReviewByIdKra: {
    url: (id) =>
      `${backendDomain}/api/hr/kra/reviews/view-one/${id}`,
    method: "get",
  },
  getReporteesReviews: {
    url: `${backendDomain}/api/hr/kra/reviews/reportees`,
    method: "get",
  },
  listReviewsKra: {
    url: `${backendDomain}/api/hr/kra/reviews/view-all`,
    method: "get",
  },

  // ===================== KRA OVERVIEW ROUTES =====================
  getAdminKraOverview: {
    url: `${backendDomain}/api/hr/kra/admin/summary-overview`,
    method: "get",
  },
  getEmployeeKraOverview: {
    url: `${backendDomain}/api/hr/kra/employee/summary-overview`,
    method: "get",
  },

  // ===================== KRA ASSIGNMENT REVIEW ROUTES =====================
  createCase:{
    url: `${backendDomain}/api/hr/cases/create`,
    method: "post"
  },
  getAllCases: {
    url: `${backendDomain}/api/hr/cases/view-all`,
    method: "get",
  },
  getCaseById: {
    url: (id) =>
      `${backendDomain}/api/hr/cases/view-one/${id}`,
    method: "get",
  },
  updateCaseStatus: {
    url: (id) =>
      `${backendDomain}/api/hr/cases/${id}/status`,
    method: "patch",
  },
  deleteCase: {
    url: (id) =>
      `${backendDomain}/api/hr/cases/delete-one/${id}`,
    method: "delete",
  },
  addComment: {
    url: (id) => `${backendDomain}/api/hr/cases/${id}/comments`,
    method: "post",
  },
  addAttachment: {
    url: (id) => `${backendDomain}/api/hr/cases/${id}/attachments`,
    method: "post",
  },
  reassignCase: {
    url: (id) => `${backendDomain}/api/hr/cases/${id}/reassign`,
    method: "patch",
  },
  getCaseReportSummary: {
    url: `${backendDomain}/api/hr/cases/reports/summary`,
    method: "get",
  },
  createCaseCategory: {
    url: `${backendDomain}/api/hr/case-categories/create`,
    method: "post",
  },
  getAllCaseCategories: {
    url: `${backendDomain}/api/hr/case-categories/view-all`,
    method: "get",
  },
  updateCaseCategory: {
    url: (id) =>
      `${backendDomain}/api/hr/case-categories/update-one/${id}`,
    method: "patch",
  },
  deleteCaseCategory: {
    url: (id) =>
      `${backendDomain}/api/hr/case-categories/delete-one/${id}`,
    method: "delete",
  },

  // ===================== POLICY AND LETTERS DOCUMENT ROUTES =====================
  createPolicyDocument: {
    url: `${backendDomain}/api/hr/policies/create`,
    method: "post"
  },
  updatePolicy: {
    url: (id) => `${backendDomain}/api/hr/policies/update-one/${id}`,
    method: "put",
  },
  getAllPolicies: {
    url: `${backendDomain}/api/hr/policies/view-all`,
    method: "get",
  },
  getPolicyById: {
    url: (id) => `${backendDomain}/api/hr/policies/view-one/${id}`,
    method: "get",
  },
  deletePolicy: {
    url: (id) => `${backendDomain}/api/hr/policies/delete-one/${id}`,
    method: "delete",
  },
  downloadPolicy: {
    url: (id) => `${backendDomain}/api/hr/policies/download-one/${id}`,
    method: "get",
  },

  // ===================== POLICY VERSIONS ROUTES =====================
  createPolicyVersions: {
    url: (id) => `${backendDomain}/api/hr/policies/versions/create/${id}`,
    method: "post",
  },
  viewPolicyVersionById: {
    url: (id) => `${backendDomain}/api/hr/policies/versions/view-all/${id}`,
    method: "get",
  },
  submitPolicyApproval: {
    url: (id) => `${backendDomain}/api/hr/policies/submit-for-approval/${id}`,
    method: "post",
  },
  approvalPolicy: {
    url: (id) => `${backendDomain}/api/hr/policies/approve/${id}`,
    method: "post",
  },
  publishPolicy: {
    url: (id) => `${backendDomain}/api/hr/policies/publish/${id}`,
    method: "post",
  },
  archivePolicy: {
    url: (id) => `${backendDomain}/api/hr/policies/archive/${id}`,
    method: "post",
  },

  // ===================== POLICY ASSIGNMENTS ROUTES =====================
  assignPolicy: {
    url: (id) => `${backendDomain}/api/hr/policies/assignments/${id}`,
    method: "post",
  },
  getPolicyAssignments: {
    url: (id) => `${backendDomain}/api/hr/policies/assignments/view/${id}`,
    method: "get",
  },

  // ===================== POLICY ACKNOWLEDGEMENTS ROUTES =====================
  getPolicyAcknowledgementsReport: {
    url: (id) => `${backendDomain}/api/hr/policies/acknowledgements/${id}`,
    method: "get",
  },
  exportPolicyAcknowledgementsReport: {
    url: (id) => `${backendDomain}/api/hr/policies/acknowledgements/export/${id}`,
    method: "get",
  },
  acknowledgePolicy: {
    url: (id) => `${backendDomain}/api/hr/policies/acknowledge/${id}`,
    method: "post",
  },
  bulkRemindPolicy: {
    url: `${backendDomain}/api/hr/policies/bulk-remind`,
    method: "post",
  },

  // ===================== EMPLOYEE SELF-SERVICE ROUTES =====================
  getMyPolicies: {
    url: `${backendDomain}/api/hr/my/policies`,
    method: "get",
  },
  getMyPoliciesPendingCount: {
    url: `${backendDomain}/api/hr/my/policies/pending-count`,
    method: "get",
  },

  // ===================== ONBOARDING INTEGRATION ROUTES =====================
  getMandatoryOnboardingPolicies: {
    url: `${backendDomain}/api/hr/onboarding/mandatory-policies`,
    method: "get",
  },

  // ===================== POLICY DASHBOARD ROUTES =====================
  getPolicyDashboardSummary: {
    url: `${backendDomain}/api/hr/policies/dashboard/summary`,
    method: "get",
  },
  getPolicyDashboardExpiring: {
    url: `${backendDomain}/api/hr/policies/dashboard/expiring`,
    method: "get",
  },

// ===================== POLICY CATEGORIES ROUTES =====================
  getPolicyCategories: {
    url: `${backendDomain}/api/hr/policy-categories`,
    method: "get"
  },
  createPolicyCategory: {
    url: `${backendDomain}/api/hr/policy-categories`,
    method: "post"
  },
  updatePolicyCategory: {
    url: (id) => `${backendDomain}/api/hr/policy-categories/${id}`,
    method: "put"
  },
  deletePolicyCategory: {
   url: (id) => `${backendDomain}/api/hr/policy-categories/${id}`,
   method: "delete"
  },

  // ===================== HR - LMS =====================
  createLmsCourse: {
    url: `${backendDomain}/api/hr/lms-courses/create`,
    method: "post",
  },
  getAllLmsCourses: {
    url: `${backendDomain}/api/hr/lms-courses/view-all`,
    method: "get",
  },
  getLmsCourseById: {
    url: (id) =>
      `${backendDomain}/api/hr/lms-courses/view-one/${id}`,
    method: "get",
  },
  updateLmsCourse: {
    url: (id) =>
      `${backendDomain}/api/hr/lms-courses/update-one/${id}`,
    method: "put",
  },
  deleteLmsCourse: {
    url: (id) =>
      `${backendDomain}/api/hr/lms-courses/delete-one/${id}`,
    method: "delete",
  },
  publishLms: {
    url: (id) => `${backendDomain}/api/hr/lms-courses/${id}/publish`,
    method: "patch",
  },

  // ===================== HR - TAGGED LMS =====================
  createTaggedLms: {
    url: `${backendDomain}/api/hr/tagged-lms-courses/create`,
    method: "post",
  },
  getAllTaggedLmsCourses: {
    url: `${backendDomain}/api/hr/tagged-lms-courses/view-all`,
    method: "get",
  },
  getTaggedLmsCourseById: {
    url: (id) =>
      `${backendDomain}/api/hr/tagged-lms-courses/view-one/${id}`,
    method: "get",
  },
  updateTaggedLmsCourse: {
    url: (id) =>
      `${backendDomain}/api/hr/tagged-lms-courses/update-one/${id}`,
    method: "put",
  },
  deleteTaggedLmsCourse: {
    url: (id) =>
      `${backendDomain}/api/hr/tagged-lms-courses/delete-one/${id}`,
    method: "delete",
  },

  // ===================== OPEN LEADS ROUTES =====================

  getOpenLeads: {
    url: `${backendDomain}/api/open-leads/view-all`,
    method: "get",
  },

  getAllLeads: {
    url: `${backendDomain}/api/open-leads/view-all`,
    method: "get",
  },
  createOpenLead: {
    url: `${backendDomain}/api/open-leads/create`,
    method: "post",
  },
  updateOpenLead: {
    url: (id) => `${backendDomain}/api/open-leads/update/${id}`,
    method: "put",
  },
  getOpenLeadById: {
    url: (id) => `${backendDomain}/api/open-leads/view-one/${id}`,
    method: "get",
  },
  convertLeadToVisit: {
    url: `${backendDomain}/api/client-visits/convert-lead`,
    method: "post",
  },
 
// ===================== EXPO SYSTEM ROUTES =====================
  createExpo: {
    url: `${backendDomain}/api/expo/create`,
    method: "post"
  },
  getAllExpos: {
    url: `${backendDomain}/api/expo/view-all`,
    method: "get"
  },
  getAllExpoLeads: {
    url: `${backendDomain}/api/expo/expo-leads/view-all`,
    method: "get"
  },
    getOneExpoLead: {
    url: (id) => `${backendDomain}/api/expo/expo-leads/view-one/${id}`,
    method: "get"
  },
  getPublicExpoDetails: {
    url: (expoId) => `${backendDomain}/api/public/expo-details/${expoId}`,
    method: "get"
  },
  submitPublicExpoLead: {
    url: (expoId) => `${backendDomain}/api/public/expo-capture/${expoId}`,
    method: "post"
  },

  // PUSH NOTIFICATIONS
  
  getMyPolicyNotifications: {
    url: `${backendDomain}/api/workflows-notifications/my/notifications`,
    method: "get",
  },
  markMyPolicyNotificationRead: {
    url: (id) => `${backendDomain}/api/workflows-notifications/my/notifications/${id}/read`,
    method: "post",
  },

  registerPushNotification: {
    url: `${backendDomain}/api/workflows-notifications/push-notifications/register`,
    method: "post",
  },
  sendPushNotification:{
    url:`${backendDomain}/api/workflows-notifications/push-notifications/send`,
    method:"POST"
  },
  sendPushToUser:{
    url:`${backendDomain}/api/workflows-notifications/push-notifications/send-user`,
    method:"POST"
  },
  getPushHistory:{
    url:`${backendDomain}/api/workflows-notifications/push-notifications/history`,
    method:"GET"
  },
  


//     getUsers:{
//     url:`${backendDomain}/api/workflows-notifications/push-notifications/users`,
//     method:"GET"
// },

// getDepartments:{
//     url:`${backendDomain}/api/workflows-notifications/push-notifications/departments`,
//     method:"GET"
// },

// getDivisions:{
//     url:`${backendDomain}/api/workflows-notifications/push-notifications/divisions`,
//     method:"GET"
// },

// getOrganizations:{
//     url:`${backendDomain}/api/workflows-notifications/push-notifications/organizations`,
//     method:"GET"
// },

 // ===================== Email Workflows (NEW - additive only) =====================
  createWorkflow: {
    url: `${backendDomain}/api/workflows-notifications/email-workflow/create`,
    method: "post",
  },
  listWorkflows: {
    url: `${backendDomain}/api/workflows-notifications/email-workflow/view-all`,
    method: "get",
  },
  getWorkflow:  {
    url: (id) => `${backendDomain}/api/workflows-notifications/email-workflow/view-one/${id}`,
    method: "get",
  },
  updateWorkflow: {
    url: (id) => `${backendDomain}/api/workflows-notifications/email-workflow/update-one/${id}`,
    method: "put",
  },
  deleteWorkflow: {
    url: (id) => `${backendDomain}/api/workflows-notifications/email-workflow/delete-one/${id}`,
    method: "delete",
  },
  testRunWorkflow: {
    url: (id) => `${backendDomain}/api/workflows-notifications/email-workflow/${id}/test-run`,
    method: "post",
  },
  listWorkflowExecutions: {
    url: (id) => `${backendDomain}/api/workflows-notifications/email-workflow/${id}/executions`,
    method: "get",
  },
  webhookUrl: {
  url: (webhookId) =>  `${backendDomain}/api/workflows-notifications/webhook/${webhookId}`,
  method: "post", // optional
},
  // WHATSAPP 
  createWhatsAppWorkflow: {
    url: `${backendDomain}/api/workflows-notifications/whatsapp-workflow/create`,
    method: "post",
  },
  listWhatsAppWorkflows: {
    url: `${backendDomain}/api/workflows-notifications/whatsapp-workflow/view-all`,
    method: "get",
  },
  getWhatsAppWorkflow: {
    url: (id) => `${backendDomain}/api/workflows-notifications/whatsapp-workflow/view-one/${id}`,
    method: "get",
  },
  updateWhatsAppWorkflow: {
    url: (id) =>  `${backendDomain}/api/workflows-notifications/whatsapp-workflow/update-one/${id}`,
    method: "put",
  },
  deleteWhatsAppWorkflow: {
    url: (id) => `${backendDomain}/api/workflows-notifications/whatsapp-workflow/delete-one/${id}`,
    method: "delete",
  },
  testRunWhatsAppWorkflow: {
    url: (id) => `${backendDomain}/api/workflows-notifications/whatsapp-workflow/${id}/test-run`,
    method: "post",
  },
  listWhatsAppWorkflowExecutions: {
    url: (id,executionId) => `${backendDomain}/api/workflows-notifications/whatsapp-workflow/${id}/executions/${executionId}`,
    method: "get",
  },
  getWhatsAppWorkflowHistory: {
    url: `${backendDomain}/api/workflows-notifications/whatsapp-workflow/history`,
    method: "get",
  },
  whatsAppWebhook: {
    url: (webhookId) => `${backendDomain}/api/workflows-notifications/whatsapp-webhook/${webhookId}`,
    method: "post", // optional, since this is mainly used for generating the URL
  },
  createRepeatClientVisit: {
    url: `${backendDomain}/api/client-visits/add-on-deal`,
    method: "post",
  },

  // ---------------- Our Product ----------------
  createProduct: {
    url: `${backendDomain}/api/sales/our-product/create`,
    method: "post",
  },

  getAllProducts: {
    url: `${backendDomain}/api/sales/our-product/view-all`,
    method: "get",
  },

  getProductById: {
    url: (id) => `${backendDomain}/api/sales/our-product/view-one/${id}`,
    method: "get",
  },

  updateProduct: {
    url: (id) => `${backendDomain}/api/sales/our-product/update-one/${id}`,
    method: "put",
  },

  deleteProduct: {
    url: (id) => `${backendDomain}/api/sales/our-product/delete-one/${id}`,
    method: "delete",
  },

  // ---------------- Product Business Categories ----------------
  createBusinessCategory: {
    url: `${backendDomain}/api/sales/our-product/business-category/create`,
    method: "post",
  },

  getAllBusinessCategories: {
    url: `${backendDomain}/api/sales/our-product/business-category/view-all`,
    method: "get",
  },

  getBusinessCategoryById: {
    url: (id) => `${backendDomain}/api/sales/our-product/business-category/view-one/${id}`,
    method: "get",
  },

  updateBusinessCategory: {
    url: (id) => `${backendDomain}/api/sales/our-product/business-category/update-one/${id}`,
    method: "put",
  },

  deleteBusinessCategory: {
    url: (id) => `${backendDomain}/api/sales/our-product/business-category/delete-one/${id}`,
    method: "delete",
  },

  // ---------------- Branch Management ----------------
  createBranch: {
    url: `${backendDomain}/api/home/branch/create`,
    method: "post",
  },
  getAllBranches: {
    url: `${backendDomain}/api/home/branch/view-all`,
    method: "get",
  },
  getBranchById: {
    url: (id) => `${backendDomain}/api/home/branch/view-one/${id}`,
    method: "get",
  },
  updateBranch: {
    url: (id) => `${backendDomain}/api/home/branch/update-one/${id}`,
    method: "put",
  },
  deleteBranch: {
    url: (id) => `${backendDomain}/api/home/branch/delete-one/${id}`,
    method: "delete",
  },
};

export default SummaryApi;
